import React, { createContext, useContext, useState, useCallback } from 'react';

interface TestConfigSidebarState {
  collapsed: boolean;
  toggle: () => void;
  close: () => void;
}

const TestConfigSidebarContext = createContext<TestConfigSidebarState>({
  collapsed: false,
  toggle: () => {},
  close: () => {},
});

export const useTestConfigSidebar = () => useContext(TestConfigSidebarContext);

// Below `lg` the sidebar renders as an overlay drawer, so it must start closed —
// otherwise it would cover the page content on load. On desktop it starts open.
const getInitialCollapsed = (): boolean =>
  typeof window !== 'undefined' && window.matchMedia('(max-width: 1023px)').matches;

export const TestConfigSidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState<boolean>(getInitialCollapsed);
  const toggle = useCallback(() => setCollapsed((prev) => !prev), []);
  const close = useCallback(() => setCollapsed(true), []);

  return (
    <TestConfigSidebarContext.Provider value={{ collapsed, toggle, close }}>
      {children}
    </TestConfigSidebarContext.Provider>
  );
};
